import React from "react";

const LiteratureAbstracts = ({ literature, onAskCopilot, isLinking, disabled }) => {
  if (!literature) return null;

  const abstractText =
    !literature.abstract || literature.abstract === "nan"
      ? "Not Available"
      : literature.abstract;

  return (
    <div className="ev-card-2 p-3 pe-1 d-flex flex-column text-justify position-relative">
      <div className="scrollable-element vh-55 pe-2">
        <p className="ev-bold-reg ev-reg-p-blue mb-2 ev-fs-14">
          {literature.title}
        </p>

        <p className="ev-small-p-dark" style={{ lineHeight: "1.6" }}>
          {abstractText}
        </p>

        {/* <button
          type="button"
          className="position-absolute bottom-0 end-0 ev-btn-gradient-violet-round ev-btn-med ev-bold-med d-flex align-items-center gap-1 avatar-tooltip"
          onClick={onAskCopilot}
          disabled={disabled || isLinking}
          data-tooltip={disabled || isLinking ? "Wait for Search to complete" : ""}
        >
          <i className={isLinking ? "bi bi-hourglass-split" : "bi bi-stars"}></i>
          {isLinking ? "Setting up..." : "Ask Genie"}
        </button> */}
      </div>
    </div>
  );
};

export default LiteratureAbstracts;